import _HFUsage from './model';
import create from './create';

const HFUsage = _HFUsage;
HFUsage.create = create;

export default HFUsage;



// WEBPACK FOOTER //
// ./data/OnlineHomework/HFUsage/model/index.js